import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EarthSearchIcon, XCloseIcon } from '@rsos/assets/icons';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';
import { IconWrapper } from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/MapPopover.styles';
import { hidePinnedPopover } from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/mapPopoverSlice';
import { clearSelectedLocation } from '@rsos/reduxDataStore/src/features/gisSearch/gisSearchSlice';
import { useIsMapIconDisabled } from '@rsos/utils/useIsMapIconDisabled';
import {
  RegionalAddr,
  StyledPlaceName,
  StyledSecondaryAddr,
} from '../../../JurisdictionView/UniversalSearch/ConnectedUniversalSearch.styles';
import { reset } from '../../../JurisdictionView/UniversalSearch/searchSlice';

const PinnedMapPopoverHeader = ({
  location,
  isGlobalFormat,
  isGlobalSource,
}) => {
  const dispatch = useDispatch();

  const {
    PlaceName,
    StAddr,
    SubAddr,
    City,
    RegionAbbr,
    Postal,
    MetroArea,
    Region,
    Zone,
  } = location?.attributes ?? {};

  const latitude = location?.location?.y;
  const longitude = location?.location?.x;

  const city = isGlobalFormat ? City || MetroArea : MetroArea || City;
  const stateOrRegion = isGlobalFormat
    ? RegionAbbr || Region
    : Region || RegionAbbr;
  const zipOrZone = isGlobalFormat ? Postal || Zone : Zone || Postal;
  const stateAndZip = [stateOrRegion, zipOrZone].filter(Boolean).join(' ');
  const regionalAdd = [city, stateAndZip].filter(Boolean).join(', ');
  const isMapIconDisabled = useIsMapIconDisabled();

  const close = useCallback(() => {
    if (isMapIconDisabled) return;
    dispatch(reset());
    dispatch(clearSelectedLocation());
    dispatch(hidePinnedPopover());
  }, [dispatch, isMapIconDisabled]);

  return (
    <Box>
      <IconWrapper horizontal pointer alignSelf="end">
        <XCloseIcon width="12px" height="12px" onClick={close} />
      </IconWrapper>
      {PlaceName && (
        <StyledPlaceName isPinnedPopover ellipsis>
          {PlaceName}
        </StyledPlaceName>
      )}
      {StAddr && StAddr !== PlaceName && (
        <StyledSecondaryAddr isPinnedPopover isPrimary={!PlaceName} ellipsis>
          {StAddr}
        </StyledSecondaryAddr>
      )}

      {SubAddr && (
        <StyledSecondaryAddr isPinnedPopover isPrimary={!PlaceName && !StAddr}>
          {SubAddr}
        </StyledSecondaryAddr>
      )}

      {regionalAdd && (
        <RegionalAddr
          isPinnedPopover
          size="small"
          color="secondaryText"
          ellipsis
        >
          {regionalAdd}
        </RegionalAddr>
      )}

      <StyledSecondaryAddr mt={1} isPinnedPopover ellipsis>
        Lat/lng: {latitude?.toFixed(5)}, {longitude?.toFixed(5)}
      </StyledSecondaryAddr>

      <Box horizontal pt={2} m="0">
        <IconWrapper pr={1} justify="center">
          <EarthSearchIcon width="12px" height="12px" />
        </IconWrapper>
        <Text size="normal" color="secondaryText" ellipsis>
          {isGlobalSource ? 'Global Basemap' : 'Local Basemap'}
        </Text>
      </Box>
    </Box>
  );
};

export default PinnedMapPopoverHeader;
